export default {
  endpoint: process.env.BLISS_ENDPOINT,
  baseUrl: process.env.BLISS_BASE_URL,
  analytics: process.env.BLISS_ANALYTICS,
  tracking: process.env.BLISS_TRACKING
};



// WEBPACK FOOTER //
// src/env.js